// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".MultipleFlavorsSelectorResult-module-container-NhNn0{display:block}.MultipleFlavorsSelectorResult-module-headline-MCU9X{color:#373a36;font-size:12px;font-style:normal;font-weight:var(--weight-light);margin-bottom:5px}.MultipleFlavorsSelectorResult-module-selectedItemsOverview-nr9Gg{list-style:none;display:flex;flex-wrap:wrap;gap:8px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": "MultipleFlavorsSelectorResult-module-container-NhNn0",
	"headline": "MultipleFlavorsSelectorResult-module-headline-MCU9X",
	"selectedItemsOverview": "MultipleFlavorsSelectorResult-module-selectedItemsOverview-nr9Gg"
};
export default ___CSS_LOADER_EXPORT___;
